import Dashboard from "components/Template/Dashboard";
import handleErrors from "helpers/handleErrors";
import React, { useCallback, useEffect, useState } from "react";
import {
  editMemberFamily,
  groupMemberList,
  memberAddStep3,
  sync,
  userCreateStep3,
} from "services/manageFamilies";
import { checkUser } from "services/user";
import IconCheck from "icons/confirm-circle-white.svg";
import { schemaFamilyDetails } from "./validation";
import Loading from "components/Loading";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import ChildInput from "components/ChildInput";
import AdoptiveInput from "components/AdoptiveInput";
import BiologicInput from "components/BiologicInput";
import ButtonJustifyEnd from "components/ButtonJustifyEnd";
import { useHistory } from "react-router-dom";

type Props = {};

const UpdateFamilyDetails: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [isEditingEmail, setIsEditingEmail] = useState(false);

  const [groupId, setGroupId] = useState("");
  const [id, setId] = useState("");
  const [loadingMembers, setLoadingMembers] = useState(false);
  const adoptiveParents: any = [];
  const birthFamily: any = [];

  const [disabledEditChild, setDisabledEditChild] = useState(false);
  const [disabledEditAdoptiveParentsOne, setDisabledEditAdoptiveParentsOne] =
    useState(false);
  const [disabledEditAdoptiveParentsTwo, setDisabledEditAdoptiveParentsTwo] =
    useState(false);
  const [disabledEditBirthFamilyOne, setDisabledEditBirthFamilyOne] =
    useState(false);
  const [disabledEditBirthFamilyTwo, setDisabledEditBirthFamilyTwo] =
    useState(false);

  const [childIdOne, setChildIdOne] = useState("");
  const [adoptiveParentsIdOne, setAdoptiveParentsIdOne] = useState("");
  const [adoptiveParentsIdTwo, setAdoptiveParentsIdTwo] = useState("");
  const [birthFamilyIdOne, setBirthFamilyIdOne] = useState("");
  const [birthFamilyIdTwo, setBirthFamilyIdTwo] = useState("");

  const getListMembers = async () => {
    try {
      setLoadingMembers(true);
      const { data } = await groupMemberList(id);
      for (let index = 0; index < data.length; index++) {
        const member: any = data[index];

        if (member.role === "child") {
          setDisabledEditChild(true);
          if (member.userData[0]) {
            setChildIdOne(member.userData[0]._id);
            setChildEmail(member.userData[0].email);
            setChildFirstName(member.userData[0].name.split(" ")[0]);
            setChildSecondName(member.userData[0].name.split(" ")[1]);
          }
        }

        if (member.role === "adoptive parents") {
          adoptiveParents.push(member);
        }

        if (member.role === "birth family") {
          birthFamily.push(member);
        }
      }

      if (!firstEmailAdoptiveFamily && adoptiveParents[0]) {
        setDisabledEditAdoptiveParentsOne(true);
        setAdoptiveParentsIdOne(adoptiveParents[0].userData[0]._id);
        setFirstEmailAdoptiveFamily(adoptiveParents[0].userData[0].email);
        setFirstFirstNameAdoptiveFamily(
          adoptiveParents[0].userData[0].name.split(" ")[0]
        );
        setFirstLastNameAdoptiveFamily(
          adoptiveParents[0].userData[0].name.split(" ")[1]
        );
      }
      if (!secondEmailAdoptiveFamily && adoptiveParents[1]) {
        setDisabledEditAdoptiveParentsTwo(true);
        setAdoptiveParentsIdTwo(adoptiveParents[1].userData[0]._id);
        setSecondEmailAdoptiveFamily(adoptiveParents[1].userData[0].email);
        setSecondFirstNameAdoptiveFamily(
          adoptiveParents[1].userData[0].name.split(" ")[0]
        );
        setSecondLastNameAdoptiveFamily(
          adoptiveParents[1].userData[0].name.split(" ")[1]
        );
      }

      if (!firstEmailBiologicFamily && birthFamily[0]) {
        setDisabledEditBirthFamilyOne(true);
        setBirthFamilyIdOne(birthFamily[0].userData[0]._id);
        setFirstEmailBiologicFamily(birthFamily[0].userData[0].email);
        setFirstFirstNameBiologicFamily(
          birthFamily[0].userData[0].name.split(" ")[0]
        );
        setFirstLastNameBiologicFamily(
          birthFamily[0].userData[0].name.split(" ")[1]
        );
      }
      if (!secondEmailBiologicFamily && birthFamily[1]) {
        setDisabledEditBirthFamilyTwo(true);
        setBirthFamilyIdTwo(birthFamily[1].userData[0]._id);
        setSecondEmailBiologicFamily(birthFamily[1].userData[0].email);
        setSecondFirstNameBiologicFamily(
          birthFamily[1].userData[0].name.split(" ")[0]
        );
        setSecondLastNameBiologicFamily(
          birthFamily[1].userData[0].name.split(" ")[1]
        );
      }
    } catch (error: any) {
    } finally {
      setLoadingMembers(false);
    }
  };

  useEffect(() => {
    setId(history.location.pathname.split("/")[2]);
    setChildFirstName(history.location.state.groupName.split(" ")[0]);
    setChildSecondName(history.location.state.groupName.split(" ")[1]);
    if (id) {
      getListMembers();
      setGroupId(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname, id]);

  const [childEmail, setChildEmail] = useState("");
  const [childId, setChildId] = useState("");
  const [childFirstName, setChildFirstName] = useState("");
  const [childSecondName, setChildSecondName] = useState("");

  const [firstEmailAdoptiveFamily, setFirstEmailAdoptiveFamily] = useState("");
  const [firstIdAdoptiveFamily, setFirstIdAdoptiveFamily] = useState("");
  const [firstFirstNameAdoptiveFamily, setFirstFirstNameAdoptiveFamily] =
    useState("");
  const [firstLastNameAdoptiveFamily, setFirstLastNameAdoptiveFamily] =
    useState("");

  const [secondEmailAdoptiveFamily, setSecondEmailAdoptiveFamily] =
    useState("");
  const [secondIdAdoptiveFamily, setSecondIdAdoptiveFamily] = useState("");
  const [secondFirstNameAdoptiveFamily, setSecondFirstNameAdoptiveFamily] =
    useState("");
  const [secondLastNameAdoptiveFamily, setSecondLastNameAdoptiveFamily] =
    useState("");

  const [firstEmailBiologicFamily, setFirstEmailBiologicFamily] = useState("");
  const [firstIdBiologicFamily, setFirstIdBiologicFamily] = useState("");
  const [firstFirstNameBiologicFamily, setFirstFirstNameBiologicFamily] =
    useState("");
  const [firstLastNameBiologicFamily, setFirstLastNameBiologicFamily] =
    useState("");

  const [secondEmailBiologicFamily, setSecondEmailBiologicFamily] =
    useState("");
  const [secondIdBiologicFamily, setSecondIdBiologicFamily] = useState("");
  const [secondFirstNameBiologicFamily, setSecondFirstNameBiologicFamily] =
    useState("");
  const [secondLastNameBiologicFamily, setSecondLastNameBiologicFamily] =
    useState("");

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<any>();

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (
        !schemaFamilyDetails.isValidSync({
          childEmail,
          childFirstName,
          childSecondName,
          firstEmailAdoptiveFamily,
          firstFirstNameAdoptiveFamily,
          firstLastNameAdoptiveFamily,
          secondEmailAdoptiveFamily,
          secondFirstNameAdoptiveFamily,
          secondLastNameAdoptiveFamily,
          firstEmailBiologicFamily,
          firstFirstNameBiologicFamily,
          firstLastNameBiologicFamily,
          secondEmailBiologicFamily,
          secondFirstNameBiologicFamily,
          secondLastNameBiologicFamily,
        })
      ) {
        handleErrors({
          schema: schemaFamilyDetails,
          stateData: {
            childEmail,
            childFirstName,
            childSecondName,
            firstEmailAdoptiveFamily,
            firstFirstNameAdoptiveFamily,
            firstLastNameAdoptiveFamily,
            secondEmailAdoptiveFamily,
            secondFirstNameAdoptiveFamily,
            secondLastNameAdoptiveFamily,
            firstEmailBiologicFamily,
            firstFirstNameBiologicFamily,
            firstLastNameBiologicFamily,
            secondEmailBiologicFamily,
            secondFirstNameBiologicFamily,
            secondLastNameBiologicFamily,
          },
          setErrorMessage: setErrors,
        });
        setLoading(false);
        return;
      }

      if (
        !firstEmailAdoptiveFamily &&
        !firstFirstNameAdoptiveFamily &&
        !firstLastNameAdoptiveFamily &&
        !secondEmailAdoptiveFamily &&
        !secondFirstNameAdoptiveFamily &&
        !secondLastNameAdoptiveFamily
      ) {
        setErrors({
          firstEmailAdoptiveFamily: "At least one adoptive parent is required",
          firstFirstNameAdoptiveFamily:
            "At least one adoptive parent is required",
          firstLastNameAdoptiveFamily:
            "At least one adoptive parent is required",
          secondEmailAdoptiveFamily: "At least one adoptive parent is required",
          secondFirstNameAdoptiveFamily:
            "At least one adoptive parent is required",
          secondLastNameAdoptiveFamily:
            "At least one adoptive parent is required",
        });
        return;
      }

      if (
        !firstEmailBiologicFamily &&
        !firstFirstNameBiologicFamily &&
        !firstLastNameBiologicFamily &&
        !secondEmailBiologicFamily &&
        !secondFirstNameBiologicFamily &&
        !secondLastNameBiologicFamily
      ) {
        setErrors({
          firstEmailBiologicFamily: "At least one birth family is required",
          firstFirstNameBiologicFamily: "At least one birth family is required",
          firstLastNameBiologicFamily: "At least one birth family is required",
          secondEmailBiologicFamily: "At least one birth family is required",
          secondFirstNameBiologicFamily:
            "At least one birth family is required",
          secondLastNameBiologicFamily: "At least one birth family is required",
        });
        return;
      }

      const newUsers: {
        name: string;
        email: string;
        subtype: string;
        groupId: string;
      }[] = [];
      const editUsers: {
        groupId: string;
        userId: string;
        email: string;
        name: string;
        subtype: string;
      }[] = [];
      const addMembers: {
        groupId: string;
        role: string;
        userId: string;
      }[] = [];

      if (childEmail && childFirstName && childSecondName) {
        if (!childId && !disabledEditChild) {
          newUsers.push({
            name: `${childFirstName} ${childSecondName}`,
            email: childEmail,
            subtype: "child",
            groupId: groupId,
          });
        } else if (childIdOne !== "") {
          editUsers.push({
            groupId,
            userId: childIdOne,
            email: childEmail,
            name: `${childFirstName} ${childSecondName}`,
            subtype: "child",
          });
        } else {
          addMembers.push({
            groupId,
            role: "child",
            userId: childId,
          });
        }
      }

      if (firstFirstNameAdoptiveFamily && firstLastNameAdoptiveFamily) {
        if (
          !firstIdAdoptiveFamily &&
          !disabledEditAdoptiveParentsOne &&
          adoptiveParentsIdOne === ""
        ) {
          newUsers.push({
            name: `${firstFirstNameAdoptiveFamily} ${firstLastNameAdoptiveFamily}`,
            email: firstEmailAdoptiveFamily,
            subtype: "adoptive parents",
            groupId: groupId,
          });
        } else if (adoptiveParentsIdOne !== "") {
          editUsers.push({
            groupId,
            userId: adoptiveParentsIdOne,
            email: firstEmailAdoptiveFamily,
            name: `${firstFirstNameAdoptiveFamily} ${firstLastNameAdoptiveFamily}`,
            subtype: "adoptive parents",
          });
        } else {
          addMembers.push({
            groupId,
            role: "adoptive parents",
            userId: firstIdAdoptiveFamily,
          });
        }
      }

      if (secondFirstNameAdoptiveFamily && secondLastNameAdoptiveFamily) {
        if (
          !secondIdAdoptiveFamily &&
          !disabledEditAdoptiveParentsTwo &&
          adoptiveParentsIdTwo === ""
        ) {
          newUsers.push({
            name: `${secondFirstNameAdoptiveFamily} ${secondLastNameAdoptiveFamily}`,
            email: secondEmailAdoptiveFamily,
            subtype: "adoptive parents",
            groupId: groupId,
          });
        } else if (adoptiveParentsIdTwo !== "") {
          editUsers.push({
            groupId,
            userId: adoptiveParentsIdTwo,
            email: secondEmailAdoptiveFamily,
            name: `${secondFirstNameAdoptiveFamily} ${secondLastNameAdoptiveFamily}`,
            subtype: "adoptive parents",
          });
        } else {
          addMembers.push({
            groupId,
            role: "adoptive parents",
            userId: secondIdAdoptiveFamily,
          });
        }
      }

      if (firstFirstNameBiologicFamily && firstLastNameBiologicFamily) {
        if (
          !firstIdBiologicFamily &&
          !disabledEditBirthFamilyOne &&
          birthFamilyIdOne === ""
        ) {
          newUsers.push({
            name: `${firstFirstNameBiologicFamily} ${firstLastNameBiologicFamily}`,
            email: firstEmailBiologicFamily,
            subtype: "birth family",
            groupId: groupId,
          });
        } else if (birthFamilyIdOne !== "") {
          editUsers.push({
            groupId,
            userId: birthFamilyIdOne,
            email: firstEmailBiologicFamily,
            name: `${firstFirstNameBiologicFamily} ${firstLastNameBiologicFamily}`,
            subtype: "birth family",
          });
        } else {
          addMembers.push({
            groupId,
            role: "birth family",
            userId: firstIdBiologicFamily,
          });
        }
      }

      if (secondFirstNameBiologicFamily && secondLastNameBiologicFamily) {
        if (
          !secondIdBiologicFamily &&
          !disabledEditBirthFamilyTwo &&
          birthFamilyIdTwo === ""
        ) {
          newUsers.push({
            name: `${secondFirstNameBiologicFamily} ${secondLastNameBiologicFamily}`,
            email: secondEmailBiologicFamily,
            subtype: "birth family",
            groupId: groupId,
          });
        } else if (birthFamilyIdTwo !== "") {
          editUsers.push({
            groupId,
            userId: birthFamilyIdTwo,
            email: secondEmailBiologicFamily,
            name: `${secondFirstNameBiologicFamily} ${secondLastNameBiologicFamily}`,
            subtype: "birth family",
          });
        } else {
          addMembers.push({
            groupId,
            role: "birth family",
            userId: secondIdBiologicFamily,
          });
        }
      }

      let syncGetStream: any[] = [];

      if (newUsers.length > 0) {
        const promisesNewUsers = newUsers.map((user) => userCreateStep3(user));
        const data = await Promise.all(promisesNewUsers);
        const users = data
          .map((response, index) => ({
            groupId: response.data.groupId || newUsers[index].groupId,
            userId: response.data.userId,
            userType: response.data.userType || newUsers[index].subtype,
          }))
          .filter((item) => item.groupId && item.userId && item.userType);
        syncGetStream = syncGetStream.concat(users);
      }

      if (editUsers.length > 0) {
        const promisesEditUsers = editUsers.map((user) =>
          editMemberFamily(user)
        );
        await Promise.all(promisesEditUsers);

        const formatEditUsersObject = editUsers.map((user) => {
          return {
            groupId: user.groupId,
            userId: user.userId,
            userType: user.subtype,
          };
        });

        syncGetStream = syncGetStream.concat(formatEditUsersObject);
      }

      if (addMembers.length > 0) {
        const promisesAddMembers = addMembers.map((member) =>
          memberAddStep3(member)
        );
        const data = await Promise.all(promisesAddMembers);
        const users = data
          .map((response, index) => ({
            groupId: response.data.groupId || addMembers[index].groupId,
            userId: response.data.userId,
            userType: response.data.userType || addMembers[index].role,
          }))
          .filter((item) => item.groupId && item.userId && item.userType);
        syncGetStream = syncGetStream.concat(users);
      }

      await sync(syncGetStream);

      history.replace(`/manage-families/${groupId}/details`);
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  const checkEmail = useCallback(async (email: string, role: string) => {
    if (!email) {
      return;
    }

    setIsEditingEmail(false);

    try {
      setLoading(true);
      const { data } = await checkUser(email);

      if (role === "child") {
        setChildFirstName(data.name.split(" ")[0]);
        setChildSecondName(data.name.split(" ")[1]);
        setChildId(data.id);
      }

      if (role === "firstAdoptiveFamily") {
        setFirstFirstNameAdoptiveFamily(data.name.split(" ")[0]);
        setFirstLastNameAdoptiveFamily(data.name.split(" ")[1]);
        setFirstIdAdoptiveFamily(data.id);
      }

      if (role === "secondAdoptiveFamily") {
        setSecondFirstNameAdoptiveFamily(data.name.split(" ")[0]);
        setSecondLastNameAdoptiveFamily(data.name.split(" ")[1]);
        setSecondIdAdoptiveFamily(data.id);
      }

      if (role === "firstBiologyFamily") {
        setFirstFirstNameBiologicFamily(data.name.split(" ")[0]);
        setFirstLastNameBiologicFamily(data.name.split(" ")[1]);
        setFirstIdBiologicFamily(data.id);
      }

      if (role === "secondBiologyFamily") {
        setSecondFirstNameBiologicFamily(data.name.split(" ")[0]);
        setSecondLastNameBiologicFamily(data.name.split(" ")[1]);
        setSecondIdBiologicFamily(data.id);
      }
    } catch (error) {
      if (role === "child") {
        setDisabledEditChild(false);
      }

      if (role === "firstAdoptiveFamily") {
        setDisabledEditAdoptiveParentsOne(false);
      }

      if (role === "secondAdoptiveFamily") {
        setDisabledEditAdoptiveParentsTwo(false);
      }

      if (role === "firstBiologyFamily") {
        setDisabledEditBirthFamilyOne(false);
      }

      if (role === "secondBiologyFamily") {
        setDisabledEditBirthFamilyTwo(false);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <Dashboard
      icon={ArrowLeft}
      breadcrumb={[
        { name: "Manage Families", active: false, path: "/manage-families" },
        {
          name: history.location.state.groupName,
          active: false,
          path: `/manage-families/${groupId}/details`,
        },
        { name: "Edit", active: true },
      ]}
      title="Edit Family Details"
      children={
        <div className="bg-bt-white p-4">
          <Loading loading={loading || loadingMembers} />
          <div className="w-9/12 mx-auto mt-4">
            <ChildInput
              email={childEmail}
              setEmail={setChildEmail}
              isHelpEmail={errors?.childEmail}
              helpTextEmail={errors?.childEmail}
              firstName={childFirstName}
              setFirstName={setChildFirstName}
              isHelpFirstName={errors?.childFirstName}
              helpTextFirstName={errors?.childFirstName}
              secondName={childSecondName}
              setSecondName={setChildSecondName}
              isHelpSecondName={errors?.childSecondName}
              helpTextSecondName={errors?.childSecondName}
              checkEmail={checkEmail}
              setIsEditingEmail={setIsEditingEmail}
              // disabled={disabledEditChild}
            />

            <AdoptiveInput
              firstEmail={firstEmailAdoptiveFamily}
              setFirstEmail={setFirstEmailAdoptiveFamily}
              isHelpFirstEmail={errors?.firstEmailAdoptiveFamily}
              helpTextFirstEmail={errors?.firstEmailAdoptiveFamily}
              firstName={firstFirstNameAdoptiveFamily}
              setFirstName={setFirstFirstNameAdoptiveFamily}
              isHelpFirstName={errors?.firstFirstNameAdoptiveFamily}
              helpTextFirstName={errors?.firstFirstNameAdoptiveFamily}
              secondName={firstLastNameAdoptiveFamily}
              setSecondName={setFirstLastNameAdoptiveFamily}
              isHelpSecondName={errors?.firstLastNameAdoptiveFamily}
              helpTextSecondName={errors?.firstLastNameAdoptiveFamily}
              secondEmail={secondEmailAdoptiveFamily}
              setSecondEmail={setSecondEmailAdoptiveFamily}
              isHelpSecondEmail={errors?.secondEmailAdoptiveFamily}
              helpTextSecondEmail={errors?.secondEmailAdoptiveFamily}
              secondFirstName={secondFirstNameAdoptiveFamily}
              setSecondFirstName={setSecondFirstNameAdoptiveFamily}
              isHelpSecondFirstName={errors?.secondFirstNameAdoptiveFamily}
              helpTextSecondFirstName={errors?.secondFirstNameAdoptiveFamily}
              secondSecondName={secondLastNameAdoptiveFamily}
              setSecondSecondName={setSecondLastNameAdoptiveFamily}
              isHelpSecondSecondName={errors?.secondLastNameAdoptiveFamily}
              helpTextSecondSecondName={errors?.secondLastNameAdoptiveFamily}
              checkEmail={checkEmail}
              setIsEditingEmail={setIsEditingEmail}
            />

            <BiologicInput
              firstEmail={firstEmailBiologicFamily}
              setFirstEmail={setFirstEmailBiologicFamily}
              isHelpFirstEmail={errors?.firstEmailBiologicFamily}
              helpTextFirstEmail={errors?.firstEmailBiologicFamily}
              firstName={firstFirstNameBiologicFamily}
              setFirstName={setFirstFirstNameBiologicFamily}
              isHelpFirstName={errors?.firstFirstNameBiologicFamily}
              helpTextFirstName={errors?.firstFirstNameBiologicFamily}
              secondName={firstLastNameBiologicFamily}
              setSecondName={setFirstLastNameBiologicFamily}
              isHelpSecondName={errors?.firstLastNameBiologicFamily}
              helpTextSecondName={errors?.firstLastNameBiologicFamily}
              secondEmail={secondEmailBiologicFamily}
              setSecondEmail={setSecondEmailBiologicFamily}
              isHelpSecondEmail={errors?.secondEmailBiologicFamily}
              helpTextSecondEmail={errors?.secondEmailBiologicFamily}
              secondFirstName={secondFirstNameBiologicFamily}
              setSecondFirstName={setSecondFirstNameBiologicFamily}
              isHelpSecondFirstName={errors?.secondFirstNameBiologicFamily}
              helpTextSecondFirstName={errors?.secondFirstNameBiologicFamily}
              secondSecondName={secondLastNameBiologicFamily}
              setSecondSecondName={setSecondLastNameBiologicFamily}
              isHelpSecondSecondName={errors?.secondLastNameBiologicFamily}
              helpTextSecondSecondName={errors?.secondLastNameBiologicFamily}
              checkEmail={checkEmail}
              setIsEditingEmail={setIsEditingEmail}
            />
          </div>
          <ButtonJustifyEnd
            title={"Confirm"}
            iconLeft={IconCheck}
            action={handleSubmit}
            disabled={isEditingEmail}
          />
        </div>
      }
    />
  );
};

export default UpdateFamilyDetails;
